import React, { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import PageShell from "@/components/PageShell";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import PasswordInput from "@/components/PasswordInput";
import { extractApiErrorMessage } from "@/lib/api";
import { toast } from "sonner";

const Login = () => {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const next = params.get("next") || "/dashboard";
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("مرحبًا بك من جديد");
      navigate(next);
    } catch (err) {
      toast.error(extractApiErrorMessage(err, "بيانات غير صحيحة"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <PageShell>
      <section className="max-w-md mx-auto px-6 py-16">
        <div className="card-warm p-8">
          <div className="flex justify-center mb-4">
            <img
              src="https://customer-assets.emergentagent.com/job_counsel-marketplace/artifacts/60nvz0lu_%D8%A3%D9%86%D8%A7%20%D8%A7%D9%84%D8%AE%D8%A7%D9%84%D8%AF%D9%8A%20%28%D8%A7%D9%84%D9%84%D9%88%D9%82%D9%88%20%D8%A7%D9%84%D9%86%D9%87%D8%A7%D8%A6%D9%8A%29.png"
              alt="أنا الخالدي"
              className="h-28 sm:h-32 w-auto object-contain select-none"
              draggable="false"
            />
          </div>
          <h1 className="font-heading text-3xl text-[#222222]">تسجيل الدخول</h1>
          <p className="text-[#5E5C58] text-sm mt-2">
            أدخل بياناتك للوصول إلى حسابك ومتابعة الجلسات والكتب.
          </p>
          <form onSubmit={submit} className="mt-6 space-y-4">
            <div>
              <Label htmlFor="email">البريد الإلكتروني</Label>
              <Input
                id="email"
                data-testid="login-email-input"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                className="mt-2"
                dir="ltr"
              />
            </div>
            <div>
              <Label htmlFor="password">كلمة المرور</Label>
              <PasswordInput
                id="password"
                data-testid="login-password-input"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                className="mt-2"
              />
              <div className="mt-3 text-end">
                <Link
                  to="/forgot-password"
                  data-testid="login-forgot-link"
                  className="inline-block text-sm font-semibold text-[#0A4D3C] hover:text-[#063A2D] underline underline-offset-4"
                >
                  نسيت كلمة المرور؟
                </Link>
              </div>
            </div>
            <Button
              data-testid="login-submit-btn"
              type="submit"
              disabled={loading}
              className="w-full rounded-full bg-[#0A4D3C] hover:bg-[#063A2D] text-white h-11"
            >
              {loading ? "جاري الدخول..." : "دخول"}
            </Button>
          </form>
          <p className="text-sm text-[#5E5C58] mt-6 text-center">
            ليس لديك حساب؟{" "}
            <Link to="/register" data-testid="login-go-register-link" className="text-[#0A4D3C] underline">
              سجّل الآن
            </Link>
          </p>
        </div>
      </section>
    </PageShell>
  );
};

export default Login;
